import { render, staticRenderFns } from "./PrinterBindingList.vue?vue&type=template&id=f0e8e0aa&"
import script from "./PrinterBindingList.vue?vue&type=script&lang=js&"
export * from "./PrinterBindingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports